import { Component, HostListener, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavParams, Events, ToastController, } from 'ionic-angular';
import { DriveServiceProvider } from '../../../providers/drive-service/drive-service';
import { ViewController } from 'ionic-angular';
import { EncrDecrServiceProvider } from '../../../providers/encr-decr-service/encr-decr-service';
import { ConfigureServiceProvider } from '../../../providers/configure-service/configure-service';
import { ConfigApiServiceProvider } from '../../../providers/config-api-service/config-api-service';
import { StoreWrapProvider } from '../../../providers/store-wrap/store-wrap';
import { ContactManagerProvider } from '../../../providers/contact-manager/contact-manager';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { DatePipe } from '@angular/common';
declare var jQuery;

@Component({
  selector: 'advance-search',
  templateUrl: 'advance-search.html'
})
export class AdvanceSearchComponent {
  conditionOpt: any = {
    'Text': [
      { key: 'contains', value: 'Contains' },
      { key: 'notContains', value: 'Not contains' },
      { key: 'equals', value: 'Equals' },
      { key: 'notEqual', value: 'Not equal' },
      { key: 'startsWith', value: 'Starts with' },
      { key: 'endsWith', value: 'Ends with' },
    ],
    'Date': [
      { key: 'notContains', value: 'Not contains' },
      { key: 'equals', value: 'Equals' },
      { key: 'greaterThan', value: 'Greater than' },
      { key: 'lessThan', value: 'Less than' },
      { key: 'notEqual', value: 'Not equal' },
      { key: 'inRange', value: 'In range' },
    ]
  };
  operatorOpt: any = [
    { key: 'AND', value: 'AND' },
    { key: 'OR', value: 'OR' },
  ];
  fieldProps: any = [];
  arrTemplates: any = [];
  fields: any;
  templatefields: any;
  folderId: any;
  fieldIndex: number;
  dateField: boolean = false;
  setDateFromIndex: any = [];
  setDateToIndex: any = [];
  fieldSelectOpt: any = [];
  fieldProperties: any;
  dropdownSettings = {};
  singleTextCondition = {}
  multipleTextCondition = {}
  filterType: any = '';
  fieldDataType: any;
  dateToField: boolean = false;
  removeConditionIcon: any = false;
  defSettings: any = {
    bigBanner: false,
    timePicker: false,
    format: 'yyyy-MM-dd',
    defaultOpen: false,
  }
  objCurrentFolder: any;
  objUpdateFolder: any;
  params: any;
  templateID: any;
  objFilterdata: any;
  data: any = [];
  fliterparams: any;
  editsummary: any = [];
  filtervalidate: boolean;
  ruleConditions: any = [];
  ObjFilterParams = {};
  defaultOption = 'Choose...'
  constructor(public navParams: NavParams, public element: ElementRef, public datePipe: DatePipe, private contextMenuService: ContextMenuService, public storeWrap: StoreWrapProvider, public contactManager: ContactManagerProvider, public configApiService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider, private driveService: DriveServiceProvider, public viewCtrlSecurity: ViewController, private EncrDecrService: EncrDecrServiceProvider, public event: Events, private toastController: ToastController) {
  }
  ngOnInit() {
    this.templatefields = this.navParams.get('templatefields');
    this.fieldProperties = this.navParams.get('fieldProperties');
    this.params = this.navParams.get('params');
    this.fields = this.templatefields.fields;
    this.folderId = this.templatefields.folderId;
    this.fields.forEach(element => {
      let isForm = 1
      let ruleConditionData = {}
      if (element.IsForm == isForm) {
        ruleConditionData = {
          "key": element.FieldName,
          "value": element.DisplayName,
        }
      }
      this.ruleConditions.push(ruleConditionData);
    });
    this.templateID = this.navParams.get('templateID');
    this.objCurrentFolder = this.navParams.get('currentFolder')
    if (this.objCurrentFolder.template.length == 0) {
      this.objCurrentFolder = JSON.parse(this.driveService.objBckupObjFolerProperties)
    }
    if (Object.keys(this.objCurrentFolder.template[0].filterParams).length == 0) {
      var defalutField = {
        fieldName: "field 1",
        fieldValue: "",
        FieldDataType: "",
        childField1: true,
        filterConditionIdx: 0,
        conditionValue: '',
        fields: this.fields,
        condition: '',
        operatorValue: 'AND',
        operators: this.operatorOpt,
        action: 'update',
        filterType: '',
        dateFrom: '',
        dateTo: ''
      }
      this.fieldProps.push(defalutField);
    } else {
      this.data = Object.keys(this.objCurrentFolder.template[0].filterParams)
      this.fliterparams = this.objCurrentFolder.template[0].filterParams
      for (var i = 0; i < this.data.length; i++) {
        if (this.data[i]) {
          for (let key in this.fliterparams[this.data[i]]) {
            let value = this.fliterparams[this.data[i]][key];
            if (value.operator) {
              value.fieldTemplate = this.data[i];
              this.editsummary.push(value)
            }
          }
        }
      }
    }
    this.editConditionFilter()

  }
  editConditionFilter() {
    this.editsummary.forEach((element, i) => {
      this.editcondition(element, i);
    });
  }
  editcondition(elem, i) {
    let fieldValue = elem.filter;
    let fielName = elem.fieldTemplate;
    if (this.fields.findIndex(item => item.FieldName == fielName) != -1) {
      this.fieldIndex = this.fields.findIndex(item => item.FieldName == fielName);
    } else {
      this.fieldIndex = 0;
    }
    if (!isNaN(Date.parse(elem.dateFrom))) {
      // if (elem.dateFrom.split("-").length >= 2) {
      this.setDateFromIndex['setDateFrom' + i] = elem.dateFrom;
      // }
    }
    if (this.fields[this.fieldIndex]["FieldDataType"] == "SELECT") {
      this.fieldLookup(this.fieldProperties.find(elem => elem.FieldName == fielName[0]));
    }
    var defalutField = {
      fieldName: "field 1",
      fieldValue: elem.fieldTemplate,
      FieldDataType: "",
      childField1: this.fields[this.fieldIndex]["FieldDataType"] != "DATE" ? true : false,
      childField2: this.fields[this.fieldIndex]["FieldDataType"] == "DATE" ? true : false,
      filterConditionIdx: 0,
      conditionValue: elem.filter,
      fields: this.fields,
      condition: elem.type,
      operatorValue: elem.operator,
      operators: this.operatorOpt,
      action: 'update',
      filterType: elem.filterType,
      dateFrom: '',
      dateTo: '',
      fieldsDisable: true
    }
    this.fieldProps.push(defalutField);
    this.removeConditionIcon = true;
  }

  getCondition(e, i) {
    this.fieldIndex = 0;
    this.fieldProps[i].filterdateIdx = 0;
    this.fieldIndex = e.i - 1;
    let data = e.event;
    if (this.fieldProps[i].fields.findIndex(elem => elem.FieldName == data) != -1) {
      this.fieldProps[i]["fieldValue"] = data;
      this.fieldProps[i]['FieldDataType'] = this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"];
      if (this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"] == "DATE") {
        this.setDateFromIndex["setDateFrom" + i] = new Date().toString();
        this.setDateToIndex["setDateTo" + i] = new Date().toString();
        this.filterDateDynamicModel(i);
        this.fieldProps[i]['childField1'] = false;
        this.fieldProps[i]['childField2'] = true;
        this.fieldProps[i]['filterType'] = 'date'
      } else {
        this.filterDateDynamicModel(i);
        this.fieldProps[i]['childField1'] = true;
        this.fieldProps[i]['childField2'] = false;
        this.fieldProps[i]['filterType'] = 'TEXT'
      }
    }
  }

  addCondition() {
    var defalutField = {
      fieldName: "field 1",
      fieldValue: "",
      FieldDataType: "",
      childField1: true,
      filterConditionIdx: 0,
      conditionValue: '',
      fields: this.fields,
      condition: this.defaultOption,
      operatorValue: 'AND',
      operators: this.operatorOpt,
      action: 'update',
      filterType: '',
      dateFrom: '',
      dateTo: '',
      fieldsDisable: false
    }
    this.fieldProps.push(defalutField);
    if (this.fieldProps.filter(element => element.action == 'update').length > 1) {
      this.removeConditionIcon = true;
    }
  }

  removeCondition(e, index) {
    this.fieldProps.splice(index, 1);
    if (this.fieldProps.length == 1) {
      this.removeConditionIcon = false;
    }
  }

  onSelectFromDate(e, index) {
    this.setDateFromIndex['setDateFrom' + index] = e;
  }
  onSelectToDate(e, index) {
    this.setDateToIndex['setDateTo' + index] = e;
  }
  emptyCondition(index) {
    this.fieldProps[index]["fieldValue"] = "";
    this.fieldProps[index]["operatorValue"] = "";
    this.fieldProps[index]["childFieldValue"] = "";
    this.fieldProps[index]["conditionValue"] = "";
    this.fieldProps[index]["filterConditionIdx"] = 0;
    this.fieldProps[index]["filterConditionIdxNext"] = 0;
    this.fieldProps[index]["FieldDataType"] = "";
  }

  filterDateDynamicModel(index) {
    delete this.setDateFromIndex["setDateFrom" + index];
    delete this.setDateToIndex["setDateTo" + index];
  }

  fieldLookup(sysfldProp) {
    if (sysfldProp && sysfldProp.FieldValues != "") {
      let optionValArr = JSON.parse(sysfldProp.FieldValues);
      if (!this.fieldSelectOpt[sysfldProp.FieldName]) {
        var fieldOpt = []
        optionValArr.forEach(optionValue => {
          fieldOpt.push({ key: optionValue[Object.keys(optionValue)[1]], label: optionValue[Object.keys(optionValue)[1]] });
        });
        this.fieldSelectOpt[sysfldProp.FieldName] = { 'options': fieldOpt };
      }
    }
  }

  //******* GET Filter Condition******** */
  getFilter(e, i) {
    this.fieldProps[i].filterConditionIdx = e.i;
    this.fieldProps[i].condition = e.event;
    if (e.event == 'inRange') {
      this.dateToField = true;
    } else {
      this.dateToField = false;
    }
  }

  onSelectOpt(e, i) {
    this.fieldProps[i].filterConditionIdx = e.i;
    this.fieldProps[i].operatorValue = e.event;
  }

  applyFilter() {
    let filterFields = [];
    let objConditionData = []
    this.filtervalidate = true;
    let pushCondition = {};
    if (this.fieldProps["length"]) {
      for (var i = 0; i < this.fieldProps.length; i++) {
        var element = this.fieldProps[i];
        let fieldValue, fieldCondition, Operator, filterType, sheduleFilter, dateFrom, dateTo;
        var field: any = this.fieldProps[i].fieldValue || '';
        fieldCondition = this.fieldProps[i].condition || '';
        filterType = this.fieldProps[i].filterType || '';
        if (this.fieldProps[i].filterType == "date") {
          if (this.setDateFromIndex['setDateFrom' + i] == undefined || this.setDateFromIndex['setDateFrom' + i] == null) {
            dateFrom = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
            dateTo = this.getTodate(dateTo, i)
          } else {
            dateTo = this.getTodate(dateTo, i)
            dateFrom = this.datePipe.transform(this.setDateFromIndex['setDateFrom' + i], 'yyyy-MM-dd');
          }
        } else if (this.setDateFromIndex['setDateFrom' + i] != null || this.setDateToIndex['setDateTo' + i] != null && element['filterType'] != 'date') {
          fieldValue = '';
        } else {
          fieldValue = this.fieldProps[i].conditionValue;
        }
        Operator = this.fieldProps[i].operatorValue || '';
        var filtertype = element['filterType'].toLowerCase()
        if (filtertype === 'text') {
          pushCondition = {
            'fieldValue': field,
            "filter": fieldValue,
            'filterType': filtertype,
            'type': fieldCondition,
          }
        } else {
          pushCondition = {
            'fieldValue': field,
            'dateTo': dateTo,
            'dateFrom': dateFrom,
            'type': fieldCondition,
            'filterType': element['filterType'],
          }
        }

        if (Operator != '') {
          pushCondition['operator'] = Operator;
        }
        if (fieldValue == '' || field == '' || pushCondition['operator'] == '' || filterType == '' || fieldCondition == '') {
          const toast = this.toastController.create({
            message: 'fields is empty!!',
            duration: this.configApiService.toastDuration
          });
          toast.present();
          this.filtervalidate = false;
        }
        filterFields.push(field);
        objConditionData.push(pushCondition)
      }
    }
    if (this.filtervalidate) {
      this.filterParamConstruct(filterFields, objConditionData);
    }
  }

  filterParamConstruct(filterFields, objConditionData) {
    let ObjFilterParams = {};
    filterFields.map(field => {
      let objFilterParamKey = {};
      objFilterParamKey = { [field]: {} }
      ObjFilterParams = Object.assign(ObjFilterParams, objFilterParamKey)
    })

    //**** Push Condition Based On Selected Fields***/
    Object.keys(ObjFilterParams).forEach((field) => {
      var conditionIdx;
      objConditionData.forEach((objData) => {
        if (objData.fieldValue == field) {
          conditionIdx = Object.keys(ObjFilterParams[field]).length == 0 ? conditionIdx = 1 : conditionIdx + 1;
          delete objData['fieldValue'];
          ObjFilterParams[field]['condition' + conditionIdx] = objData;
          ObjFilterParams[field]['filterType'] = objData.filterType;
        }
      })
    })

    let objCurrentFolder = JSON.stringify(this.objCurrentFolder);
    this.pushFolderProperty(ObjFilterParams, objCurrentFolder);
  }

  pushFolderProperty(ObjFilterParams, currentFolder: any) {
    this.ObjFilterParams = ObjFilterParams;
    if (typeof currentFolder == 'string') {
      var objCurrentFolder = JSON.parse(currentFolder);
    } else {
      objCurrentFolder = currentFolder
    }
    objCurrentFolder.template.forEach((element, idx) => {
      let templateProps = { 'id': this.templateID, 'filterParams': ObjFilterParams }
      objCurrentFolder.template[idx] = templateProps;
    });
    delete objCurrentFolder['files'];
    this.getFilterData(objCurrentFolder);
  }

  getFilterData(objCurrentFolder) {
    this.driveService.pullSyncData(this.templateID, this.params, objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData);
  }

  getFileData = ((data) => {
    this.driveService.objCurrentFolder = this.objCurrentFolder;
    this.objFilterdata = { 'rowsData': data, 'filterParams': this.ObjFilterParams, "flag": 'advanceSearch' };
    this.viewCtrlSecurity.dismiss(this.objFilterdata);
  });

  cancelFilter() {
    this.objFilterdata = {};
    this.viewCtrlSecurity.dismiss(this.objFilterdata);
    this.fieldProps = [];
    this.setDateFromIndex = [];
    this.setDateToIndex = [];
  }

  clearAll() {
    var ObjFilterParams = {}
    let data = [];
    this.objFilterdata = { 'rowsData': data, 'filterParams': ObjFilterParams };
    this.viewCtrlSecurity.dismiss(this.objFilterdata);
  }

  getPosition() {
    let grid_holder = document.getElementById("gridHolder");
    let topPx = grid_holder.getBoundingClientRect().top;
    let topPosition = topPx - 79;
    return topPosition;
  }
  getTodate(dateTo, i) {
    if (this.dateToField && this.setDateToIndex['setDateTo' + i] == undefined) {
      dateTo = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    } else {
      dateTo = this.datePipe.transform(this.setDateToIndex['setDateTo' + i], 'yyyy-MM-dd');
    }
    return dateTo
  }
}



// WEBPACK FOOTER //
// ./src/components/form/advance-search/advance-search.ts